import styled from "styled-components";
import { dispositivo } from "../Dispositivos";

export const ContenedorPaciente = styled.div`
  

  @media ${dispositivo.tablet} {

  }
`;